// Basit Toast Bildirim Sistemi (Vanilla JavaScript)

// Toast container oluştur
let toastContainer = null;

function initToastContainer() {
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'simple-toast-container';
    toastContainer.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 99999;
      display: flex;
      flex-direction: column;
      gap: 10px;
      pointer-events: none;
    `;
    document.body.appendChild(toastContainer);
  }
  return toastContainer;
}

// Toast göster
export function showToast(message, options = {}) {
  const {
    type = 'info', // info, success, error, warning
    duration = 5000,
    onClick = null,
    title = null
  } = options;

  const container = initToastContainer();

  // Toast elementi oluştur
  const toast = document.createElement('div');
  toast.className = `simple-toast simple-toast-${type}`;
  toast.style.cssText = `
    background: ${type === 'success' ? '#10b981' : type === 'error' ? '#ef4444' : type === 'warning' ? '#f59e0b' : '#3b82f6'};
    color: white;
    padding: 16px 20px;
    border-radius: 8px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    min-width: 300px;
    max-width: 400px;
    pointer-events: auto;
    cursor: ${onClick ? 'pointer' : 'default'};
    animation: slideInRight 0.3s ease-out;
    display: flex;
    flex-direction: column;
    gap: 8px;
  `;

  // Title varsa ekle
  if (title) {
    const titleEl = document.createElement('div');
    titleEl.style.cssText = `
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 4px;
    `;
    titleEl.textContent = title;
    toast.appendChild(titleEl);
  }

  // Mesaj ekle
  const messageEl = document.createElement('div');
  messageEl.style.cssText = `
    font-size: 14px;
    line-height: 1.5;
  `;
  messageEl.textContent = message;
  toast.appendChild(messageEl);

  // Close button ekle
  const closeBtn = document.createElement('button');
  closeBtn.innerHTML = '×';
  closeBtn.style.cssText = `
    position: absolute;
    top: 8px;
    right: 8px;
    background: transparent;
    border: none;
    color: white;
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.8;
    transition: opacity 0.2s;
  `;
  closeBtn.onmouseenter = () => closeBtn.style.opacity = '1';
  closeBtn.onmouseleave = () => closeBtn.style.opacity = '0.8';
  closeBtn.onclick = (e) => {
    e.stopPropagation();
    removeToast(toast);
  };
  toast.appendChild(closeBtn);

  // Click handler
  if (onClick) {
    toast.onclick = (e) => {
      if (e.target !== closeBtn) {
        onClick();
        removeToast(toast);
      }
    };
  }

  // Container'a ekle
  container.appendChild(toast);

  // Otomatik kaldır
  if (duration > 0) {
    setTimeout(() => {
      removeToast(toast);
    }, duration);
  }

  return toast;
}

// Toast kaldır
function removeToast(toast) {
  if (toast && toast.parentNode) {
    toast.style.animation = 'slideOutRight 0.3s ease-in';
    setTimeout(() => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    }, 300);
  }
}

// CSS animasyonları ekle
if (!document.getElementById('simple-toast-styles')) {
  const style = document.createElement('style');
  style.id = 'simple-toast-styles';
  style.textContent = `
    @keyframes slideInRight {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    
    @keyframes slideOutRight {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(100%);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);
}

// Helper fonksiyonlar
export const toast = {
  info: (message, options) => showToast(message, { ...options, type: 'info' }),
  success: (message, options) => showToast(message, { ...options, type: 'success' }),
  error: (message, options) => showToast(message, { ...options, type: 'error' }),
  warning: (message, options) => showToast(message, { ...options, type: 'warning' }),
};
